import { makeStyles } from '@material-ui/core'

export default makeStyles((theme) => ({
  gridItem: {
    maxHeight: 500,
  },
  isLoading: {
    height: 500,
  },
  tableHead: {
    '& th': {
      backgroundColor: theme.palette.primary.main,
      color: theme.palette.common.white,
    },
  },
}))
